import React, { useRef } from 'react'
import { HeaderSearchContext } from 'providers/HeaderSearchProvider'
import { useTranslation } from 'react-i18next'

export interface Props {
  onSearch: () => void
  onCancel: () => void
  onFocus: () => void
  goToLink: (url: string) => void
  children?: React.ReactNode
}

const HeaderSearchBar: React.FC<Props> = ({ children, onSearch, onCancel, onFocus, goToLink }) => {
  const { t } = useTranslation()
  const lastSearchPhrase = useRef<string | undefined>('')

  return (
    <div className="flex items-center">
      <div className={'my-0 ml-3 sm:mx-16 grow'}>
        <HeaderSearchContext.Consumer>
          {(p) => {
            const { searchPhrase, actions } = p ?? {}
            const {
              setSearchPhrase,
              increaseActiveIndex,
              decreaseActiveIndex,
              resetActiveIndex,
              getActiveLink,
            } = actions ?? {}
            return (
              <input
                placeholder={t('general.search_placeholder')}
                onBlur={() => {
                  lastSearchPhrase.current = ''
                  onCancel()
                }}
                onFocus={onFocus}
                onChange={(e) => setSearchPhrase?.(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Escape') {
                    e.currentTarget.blur()
                  } else if (e.key === 'ArrowUp') {
                    decreaseActiveIndex?.()
                  } else if (e.key === 'ArrowDown') {
                    increaseActiveIndex?.()
                  }
                  if (e.ctrlKey) {
                    if (e.key === 'j') {
                      increaseActiveIndex?.()
                    } else if (e.key === 'k') {
                      decreaseActiveIndex?.()
                    }
                  }
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter' && searchPhrase !== '') {
                    if (lastSearchPhrase.current !== searchPhrase) {
                      lastSearchPhrase.current = searchPhrase
                      resetActiveIndex?.()
                      onSearch()
                    } else {
                      lastSearchPhrase.current = ''
                      getActiveLink && goToLink(getActiveLink())
                      e.currentTarget.blur()
                    }
                  }
                }}
                value={searchPhrase}
                className="placeholder-gray-400 text-sm border-none text-gray-700 outline-hidden w-full h-[30px]"
              />
            )
          }}
        </HeaderSearchContext.Consumer>
        {children}
      </div>
    </div>
  )
}

export default HeaderSearchBar
